import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuHead from "../components/DixuHead/DixuHead";
import DixuHttpErrorInfo from "../components/DixuHttpErrorInfo/DixuHttpErrorInfo";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Router from 'next/router';
import React from 'react';
const NotFound = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: "Sivu on hukassa"
  }), /*#__PURE__*/React.createElement(DixuHttpErrorInfo, {
    code: 404,
    title: "Sivu on hukassa",
    actions: [{
      type: 'primary',
      children: 'Takaisin edelliselle sivulle',
      onClick: () => {
        if (document.referrer?.includes(process.env.WEB_URL)) {
          Router.back();
        } else {
          Router.push('/');
        }
      }
    }, {
      type: 'outline',
      children: 'Anna meidän kuulla kunniamme',
      href: '/ota-yhteytta'
    }]
  }));
};
export const getStaticProps = async _ref => {
  let {
    req,
    locale
  } = _ref;
  return {
    props: _objectSpread({}, await serverSideTranslations(locale || req.locale, ['common']))
  };
};
export default NotFound;